import React, { useState, useEffect } from "react";
import { Field, Form, Formik } from "formik";
import {
  generate_uuid,
  transformTranslateFromValues,
  transformTranslateServerValues,
  objectFilter,
} from "lib/helpers";
import {
  GalleryField,
  Loading,
  Select,
  File,
  TextField,
} from "components/form";
import { number, required, validationWrapper } from "lib/formValidations";
import { useWizard } from "store/wizard";
import Modal from "components/Modal";
import axios from "axios";

const Additional = (props) => {
  const wizard = useWizard();
  const [showAddTrailer, setShowAddTrailer] = useState(false);
  const [showAddReview, setShowAddReview] = useState(false);
  const [trailers, setTrailers] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [showAddSubtitle, setShowAddSubtitle] = useState(false);
  const [subtitles, setSubtitles] = useState([]);

  useEffect(() => {
    if (
      wizard.product &&
      wizard.product.product_detail &&
      wizard.product.product_detail.trailers
    ) {
      setTrailers(
        wizard.product.product_detail.trailers.map((i) => ({
          uuid: i.id,
          source: i.source,
          language: i.language,
        }))
      );
    }

    if (
      wizard.product &&
      wizard.product.product_detail &&
      wizard.product.product_detail.reviews
    ) {
      setReviews(
        wizard.product.product_detail.reviews.map((i) => ({
          uuid: i.id,
          title: i.title,
          source: i.source,
          language: i.language,
        }))
      );
    }

    if (
      wizard.product &&
      wizard.product.product_detail &&
      wizard.product.product_detail.subtitles
    ) {
      setSubtitles(
        wizard.product.product_detail.subtitles.map((i) => ({
          uuid: i.id,
          id: i.id,
          file: { name: i.file_name },
          language: i.language,
          label: i.label,
        }))
      );
    }
  }, []);

  const _renderTrailers = () => {
    return trailers.map((item, index) => (
      <div key={`item_${index}`} className="grid grid-cols-5 gap-3">
        <h5>{item.language === "en" ? "انگلیسی" : "فارسی"}</h5>
        <h5 className="col-span-3 text-left">{item.source}</h5>
        <div className="flex justify-center items-center">
          <button
            type="button"
            onClick={() => {
              setTrailers(trailers.filter((i) => i.uuid != item.uuid));
            }}
            className="btn btn-sm btn-danger"
          >
            حذف
          </button>
        </div>
      </div>
    ));
  };

  const _renderReviews = () => {
    return reviews.map((item) => (
      <div key={item.title} className="grid grid-cols-6 gap-3">
        <h5 className="">{item.title}</h5>
        <h5>{item.language === "en" ? "انگلیسی" : "فارسی"}</h5>
        <h5 className="">{item.source}</h5>
        <div className="flex justify-center items-center">
          <button
            type="button"
            onClick={() => {
              setReviews(reviews.filter((i) => i.uuid != item.uuid));
            }}
            className="btn btn-sm btn-danger"
          >
            حذف
          </button>
        </div>
      </div>
    ));
  };

  const _renderSubtitles = () => {
    return subtitles.map((item) => (
      <div key={item.label} className="grid grid-cols-6 gap-3">
        <h5>{item.language === "en" ? "انگلیسی" : "فارسی"}</h5>
        <h5>{item.label}</h5>
        <h5 className="col-span-2 text-center">
          {item.file && item.file?.name}
        </h5>
        <div className="flex justify-center items-center">
          <button
            type="button"
            onClick={() => {
              setSubtitles(subtitles.filter((i) => i.uuid != item.uuid));
            }}
            className="btn btn-sm btn-danger"
          >
            حذف
          </button>
        </div>
      </div>
    ));
  };
  if (wizard.load) {
    return (
      <>
        <div className="content">
          <div className="p-3 flex justify-center">
            <Loading />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <AddTrailer
        close={() => setShowAddTrailer(false)}
        show={showAddTrailer}
        submit={(values) => {
          setTrailers([...trailers, values]);
        }}
      />
      <AddReview
        close={() => setShowAddReview(false)}
        show={showAddReview}
        submit={(values) => {
          setReviews([...reviews, values]);
        }}
      />
      <AddSubtitle
        close={() => setShowAddSubtitle(false)}
        show={showAddSubtitle}
        submit={(values) => {
          setSubtitles([...subtitles, values]);
        }}
      />
      <div className="font-medium text-base">تصاویر و زیرنویس ها</div>
      <Formik
        key="fromik_p_base_info"
        initialValues={
          wizard.product && wizard.product.product_detail
            ? {
                ...transformTranslateServerValues(
                  objectFilter(wizard.product.product_detail, [
                    "horizontal_media_id",
                    "vertical_media_id",
                    "background_media_id",
                    "translates",
                  ])
                ),
              }
            : {}
        }
        trailers
        onSubmit={async (values, { setSubmitting }) => {
          await props.submitStep({
            ...transformTranslateFromValues(values),
            trailers: trailers.map((i) => ({
              language: i.language,
              source: i.source,
            })),
            reviews: reviews.map((i) => ({
              title: i.title,
              language: i.language,
              source: i.source,
            })),
            subtitles: subtitles.map((i) => ({
              language: i.language,
              label: i.label,
              file: i.id ? null : i.file,
              id: i.id ?? null,
            })),
          });
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, values }) => (
          <Form>
            <div className="grid grid-cols-12 gap-4 gap-y-5 mt-5">
              <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-4">
                <Field
                  label="تصویر پس زمینه :"
                  name="background_media_id"
                  component={GalleryField}
                  dataType="id"
                />
                <Field
                  label="تصویر پس زمینه انگلیسی :"
                  name="_en*background_media_id*media"
                  component={GalleryField}
                  dataType="id"
                />
              </div>
              <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-4">
                <Field
                  label="تصویر عمودی :"
                  name="vertical_media_id"
                  component={GalleryField}
                  dataType="id"
                />
                <Field
                  label="تصویر عمودی انگلیسی :"
                  name="_en*vertical_media_id*media"
                  component={GalleryField}
                  dataType="id"
                />
              </div>
              <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-4">
                <Field
                  label="تصویر افقی :"
                  name="horizontal_media_id"
                  component={GalleryField}
                  dataType="id"
                />
                <Field
                  label="تصویر افقی انگلیسی :"
                  name="_en*horizontal_media_id*media"
                  dataType="id"
                  component={GalleryField}
                />
              </div>

              <hr className="col-span-12 my-2" />

              <div className="intro-y col-span-6 border rounded p-2 border-theme-21">
                <div className="flex justify-between items-center">
                  <h2>تریلر ها :</h2>
                  <button
                    className="btn btn-sm btn-primary"
                    type="button"
                    onClick={() => setShowAddTrailer(true)}
                  >
                    افزودن تریلر
                  </button>
                </div>
                <hr className="my-2" />
                <div className="grid grid-cols-1 gap-4 mt-3">
                  <div className="grid grid-cols-5 gap-3">
                    <h5>زبان</h5>
                    <h5 className="col-span-3 text-center">لینک فایل</h5>
                    <div className="flex justify-center items-center">
                      عملیات
                    </div>
                  </div>
                  {_renderTrailers()}
                </div>
              </div>

              {wizard.type != "Serie" && (
                <div className="intro-y col-span-6 border rounded p-2 border-theme-21">
                  <div className="flex justify-between items-center">
                    <h2>زیرنویس ها :</h2>
                    <button
                      className="btn btn-sm btn-primary"
                      type="button"
                      onClick={() => setShowAddSubtitle(true)}
                    >
                      افزودن زیرنویس
                    </button>
                  </div>
                  <hr className="my-2" />
                  <div className="grid grid-cols-1 gap-4 mt-3">
                    <div className="grid grid-cols-5 gap-3">
                      <h5>زبان</h5>
                      <h5>برچسب</h5>
                      <h5 className="col-span-2 text-center">نام فایل</h5>
                      <div className="flex justify-center items-center">
                        عملیات
                      </div>
                    </div>
                    {_renderSubtitles()}
                  </div>
                </div>
              )}
              <div className="intro-y col-span-12 border rounded p-2 border-theme-21">
                <div className="flex justify-between items-center">
                  <h2>گفتوگو با کارگردان :</h2>
                  <button
                    className="btn btn-sm btn-primary"
                    type="button"
                    onClick={() => setShowAddReview(true)}
                  >
                    افزودن گفتوگو
                  </button>
                </div>
                <hr className="my-2" />
                <div className="grid grid-cols-1 gap-4 mt-3">
                  <div className="grid grid-cols-6 gap-3">
                    <h5>عنوان</h5>
                    <h5>زبان</h5>
                    <h5 className="">لینک فایل</h5>
                    <div className="flex justify-center items-center">
                      عملیات
                    </div>
                  </div>
                  {_renderReviews()}
                </div>
              </div>
              <div className="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5">
                <button
                  className="btn btn-secondary w-24"
                  type="button"
                  onClick={() => {
                    wizard.dispatch(wizard.previous());
                  }}
                  disabled={isSubmitting}
                >
                  قبلی
                </button>
                <button
                  className="btn btn-primary w-24 mr-2"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                {wizard && wizard.mode == "update" && (
                  <button
                    className="btn btn-secondary w-24 mr-2"
                    type="button"
                    onClick={() => {
                      wizard.dispatch(wizard.next());
                    }}
                    disabled={isSubmitting}
                  >
                    بعدی
                  </button>
                )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Additional;

export function AddTrailer(props) {
  return (
    <Modal show={props.show} handleClose={props.close} title="افزودن تریلر">
      <Formik
        key="fromik_p_trailer"
        initialValues={{ uuid: generate_uuid() }}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, handleSubmit, values, setFieldValue }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-3 md:gap-3">
                <div className="col-span-2">
                  <Field
                    placeholder="تبدیل ایدی به لینک تریلر"
                    label="ایدی تریلر :"
                    name="source_id"
                    component={TextField}
                  />
                </div>
                <div className="col-span-1">
                  <button
                    className="btn btn-primary w-36 h-10 mt-6"
                    type="button"
                    onClick={async () => {
                      if (values.source_id) {
                        try {
                          const result = await axios.get(
                            `https://streaming.hashure.com/getvideobyid.php?id=${values.source_id}`
                          );
                          setFieldValue("source", result.data);
                        } catch (e) {
                          setFieldValue("source", "");
                        }
                      }
                    }}
                  >
                    تولید لینک
                  </button>
                </div>
              </div>
              <div className="intro-x grid md:grid-cols-3 md:gap-3">
                <div className="col-span-1">
                  <Field
                    placeholder="زبان تریلر"
                    label="زبان تریلر :"
                    name="language"
                    component={Select}
                    options={[
                      { value: "fa", label: "فارسی" },
                      { value: "en", label: "انگلیسی" },
                    ]}
                  />
                </div>
                <div className="col-span-2">
                  <Field
                    placeholder="لینک تریلر"
                    label="لینک تریلر :"
                    name="source"
                    component={TextField}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {" "}
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function AddReview(props) {
  return (
    <Modal show={props.show} handleClose={props.close} title="افزودن گفتگو'">
      <Formik
        key="fromik_p_review"
        initialValues={{ uuid: generate_uuid() }}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, handleSubmit, values, setFieldValue }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-3 md:gap-3">
                <div className="col-span-2">
                  <Field
                    placeholder="تبدیل ایدی به لینک گفتگو"
                    label="ایدی گفتگو :"
                    name="source_id"
                    component={TextField}
                  />
                </div>
                <div className="col-span-1">
                  <button
                    className="btn btn-primary w-36 h-10 mt-6"
                    type="button"
                    onClick={async () => {
                      if (values.source_id) {
                        try {
                          const result = await axios.get(
                            `https://streaming.hashure.com/getvideobyid.php?id=${values.source_id}`
                          );
                          setFieldValue("source", result.data);
                        } catch (e) {
                          setFieldValue("source", "");
                        }
                      }
                    }}
                  >
                    تولید لینک
                  </button>
                </div>
              </div>
              <div className="intro-x grid md:grid-cols-3 md:gap-3">
                <div className="col-span-2">
                  <Field
                    placeholder="عنوان"
                    label="عنوان :"
                    name="title"
                    component={TextField}
                  />
                </div>
                <div className="col-span-1">
                  <Field
                    placeholder="زبان گفتگو"
                    label="زبان گفتگو :"
                    name="language"
                    component={Select}
                    options={[
                      { value: "fa", label: "فارسی" },
                      { value: "en", label: "انگلیسی" },
                    ]}
                  />
                </div>
                <div className="col-span-2">
                  <Field
                    placeholder="لینک گفتگو"
                    label="لینک گفتگو :"
                    name="source"
                    component={TextField}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {" "}
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function AddSubtitle(props) {
  return (
    <Modal show={props.show} handleClose={props.close} title="افزودن زیرنویس">
      <Formik
        key="fromik_p_subtitle"
        initialValues={{ uuid: generate_uuid(), id: null }}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, handleSubmit }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-2 md:gap-3">
                <div>
                  <Field
                    placeholder="زبان زیرنویس"
                    label="زبان زیرنویس :"
                    name="language"
                    component={Select}
                    options={[
                      { value: "fa", label: "فارسی" },
                      { value: "en", label: "انگلیسی" },
                    ]}
                  />
                  <Field
                    placeholder="برچسب زیرنویس"
                    label="برچسب زیرنویس :"
                    name="label"
                    component={TextField}
                  />
                </div>
                <div>
                  <Field label="فایل زیرنویس :" name="file" component={File} />
                </div>
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {" "}
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
